<div class="kw-page" [nbSpinner]="this.isLoading">

  <div class="kw-page-header">
    <div class="title-block">
      <h2 class="page-title">{{"Product" | tenantWords}} List</h2>
      <span class="page-subtitle">Manage {{"Product" | tenantWords}} definitions, varieties, and package types</span>
    </div>
    <div class="header-actions">
      <button mat-raised-button color="primary" class="header-btn primary-btn" (click)="createItem()">
        <fa-icon [icon]="faPlus" class="me-2"></fa-icon>Create {{"Product" | tenantWords}}
      </button>
    </div>
  </div>

  <div class="filters-bar">
    <kw-filter-dropdown class="filter-widget" [filterSettings]="this.dropdownSettings"
      (filterResultsChange)="setFilterResults($event)">
    </kw-filter-dropdown>
  </div>

  <div class="grid-card">
    <ejs-grid #grid [dataSource]="this.filteredItems" [columns]="this.columns" [allowPaging]="true"
      [pageSettings]="this.pageSettings" [allowSorting]="true" [allowFiltering]="true"
      [filterSettings]="this.filterSettings" [allowTextWrap]="true" [enableStickyHeader]="true"
      [enableHover]="true" (rowSelected)="onRowSelected($event)">
    </ejs-grid>
  </div>

  <!-- Mobile card list: replaces the data grid on small screens -->
  <div class="kw-mobile-list">
    <div class="m-card" *ngFor="let item of this.filteredItems | slice:0:mobileVisibleCount; trackBy: trackByItem" (click)="openDetail(item)">
      <div class="m-card-top">
        <span class="m-card-name">{{item.name}}</span>
      </div>

      <div class="m-card-meta">
        <div class="m-meta-line" *ngIf="item.description">
          <fa-icon [icon]="faAlignLeft" class="m-meta-icon"></fa-icon>{{item.description}}
        </div>
        <div class="m-meta-line" *ngIf="item.varietyName">
          <fa-icon [icon]="faSeedling" class="m-meta-icon"></fa-icon>{{item.varietyName}}
        </div>
      </div>

      <div class="m-card-foot">
        <span class="type-pill" [class.empty]="!item.packageTypeName">{{item.packageTypeName || 'No package type'}}</span>
        <div class="m-card-actions">
          <button mat-icon-button [attr.aria-label]="'Open ' + item.name" (click)="openDetail(item); $event.stopPropagation()">
            <fa-icon [icon]="faChevronRight"></fa-icon>
          </button>
        </div>
      </div>
    </div>

    <div class="m-empty" *ngIf="!this.filteredItems.length && !this.isLoading">
      <fa-icon [icon]="faBoxes" class="m-empty-icon"></fa-icon>
      <div>No {{"Product" | tenantWords}}s match your filters</div>
    </div>

    <button class="m-show-more" *ngIf="this.filteredItems.length > mobileVisibleCount"
            mat-stroked-button (click)="showMoreMobile()">
      Show more ({{this.filteredItems.length - mobileVisibleCount}} remaining)
    </button>
  </div>

</div>

<ng-template #actionTemplate let-data>
  <div class="row-actions">
    <button mat-icon-button [attr.aria-label]="'Open ' + data.name" (click)="openDetail(data); $event.stopPropagation()">
      <fa-icon [icon]="faChevronRight"></fa-icon>
    </button>
  </div>
</ng-template>
